export default "__VITE_ASSET__B4aB15kI__"